import React from 'react'

const AuthContext = React.createContext(false);

export default AuthContext;
